/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface SponsorshipProductRequest {

    /**
     * Product ID
     */
    id?: number;

    /**
     * Name of the sponsorship product
     */
    name?: string;

    /**
     * Sponsorship product sku
     */
    sku?: string;

    /**
     * Benefits for this sponsorship product
     */
    benefits?: string;

    /**
     * Image to display for this product
     */
    image_url?: string;

    /**
     * Quantity required to purchase
     */
    quantity?: number;

    /**
     * Duration of membership in months
     */
    months?: number;

    /**
     * Price in dollars
     */
    dollar_price?: number;

    /**
     * Price in cents
     */
    price?: number;

    /**
     * Whether this sponsorship product should be shown
     */
    visible?: boolean;

    /**
     * Whether this sponsorship product is recurring or fixed
     */
    recurring?: boolean;

    /**
     * Whether this sponsorship product has already been taken
     */
    taken?: boolean;

    /**
     * Whether this sponsorship product is displayed on the first page
     */
    featured?: boolean;

    /**
     * The sku of the membership product being gifted
     */
    product_sku?: string;

}

@Model('SponsorshipProduct')
export class ApiSponsorshipProduct extends BaseModel implements SponsorshipProductRequest {

    /**
     * Product ID
     */
    
    
    id: number;

    /**
     * Name of the sponsorship product
     */
    
    
    name: string;

    /**
     * Sponsorship product sku
     */
    
    
    sku: string;

    /**
     * Benefits for this sponsorship product
     */
    
    
    benefits: string;

    /**
     * Image to display for this product
     */
    
    
    image_url: string;

    /**
     * Quantity required to purchase
     */
    
    
    quantity: number;

    /**
     * Duration of membership in months
     */
    
    
    months: number;

    /**
     * Price in dollars
     */
    
    
    dollar_price: number;

    /**
     * Price in cents
     */
    
    
    price: number;

    /**
     * Whether this sponsorship product should be shown
     */
    
    
    visible: boolean;

    /**
     * Whether this sponsorship product is recurring or fixed
     */
    
    
    recurring: boolean;

    /**
     * Whether this sponsorship product has already been taken
     */
    
    
    taken: boolean;

    /**
     * Whether this sponsorship product is displayed on the first page
     */
    
    
    featured: boolean;

    /**
     * The sku of the membership product being gifted
     */
    
    
    product_sku: string;

}
